// import { useEffect, useCallback } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import { setUser, initialState } from "store/auth/userSlice";
// import { apiSignIn, apiSignUp, apigetUserDetails } from "services/AuthService";
// import { toast, Notification } from "components/ui";
// import { onSignInSuccess, onSignOutSuccess } from "store/auth/sessionSlice";
// import appConfig from "configs/app.config";
// import { REDIRECT_URL_KEY } from "constants/app.constant";
// import { useNavigate } from "react-router-dom";
// import useQuery from "./useQuery";

// function useAuth() {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const query = useQuery();
//   const { token, signedIn } = useSelector((state) => state.auth.session);

//   const handleSignOut = useCallback(() => {
//     localStorage.removeItem("userDetails");
//     localStorage.removeItem("access_token");
//     localStorage.removeItem("login_time");
//     dispatch(onSignOutSuccess());
//     dispatch(setUser(initialState));
//     navigate(appConfig.unAuthenticatedEntryPath);
//   }, [dispatch, navigate]);

//   const signOut = useCallback(() => {
//     handleSignOut();
//   }, [handleSignOut]);

// const signIn = async (values) => {
//   try {
//     const resp = await apiSignIn(values);
//     const { data, status } = resp;

//     if (data && status === 200 && !["failed", "Failed", "Error"].includes(data.status)) {
//       dispatch(onSignInSuccess(data.token));
//       localStorage.setItem("access_token", data.token);
//       localStorage.setItem("login_time", Date.now().toString());

//       try {
//         const userResp = await apigetUserDetails(data.userId);
//         if (userResp.status === 200 && userResp.data) {
//           const userDetails = userResp.data;
//           localStorage.setItem("userDetails", JSON.stringify(userDetails));

//           toast.push(
//             <Notification title="Sign In Successful" type="success" duration={5000}>
//               You have successfully signed in.
//             </Notification>,
//             { placement: "top-center" }
//           );

//           // 👇 Redirect immediately based on user role
//           const userRoles = userDetails?.userRoles || [];

//           if (userRoles.includes("player")) {
//             navigate("/Dashboard");
//           } else {
//             navigate("/home");
//           }

//           return { status: "success" };
//         }
//       } catch (err) {
//         return {
//           status: "failed",
//           message: err?.response?.data?.message || err.toString(),
//         };
//       }
//     } else {
//       toast.push(
//         <Notification title="Sign in Failed" type="warning" duration={3000}>
//           {data?.message || data?.response || "Invalid credentials"}
//         </Notification>,
//         { placement: "top-center" }
//       );
//       signOut();
//     }
//   } catch (error) {
//     signOut();
//     navigate("/sign-in");

//     return {
//       status: "failed",
//       message:
//         error?.response?.data?.message ||
//         error?.response?.data?.response ||
//         error.toString(),
//     };
//   }
// };


 
// const signUp = async (values) => {
//   try {
//     const resp = await apiSignUp(values);
//     const { data } = resp;
//     const status = data?.status?.toLowerCase();

//     if (status === "success") {
//       toast.push(
//         <Notification title = "Sign Up Successful" type ="success" duration={4000}>
//           {data?.message || "Signup successful. Please check your email to activate your account."}
//         </Notification>,
//         { placement: "top-center" }
//       );

//         navigate("/sign-in");
//       return { status: "success", message: data?.message || ""};
//     }

//     toast.push(
//       <Notification title="Sign Up Failed" type="warning" duration={3000}>
//         {data?.message || "Signup failed"}
//       </Notification>,
//       { placement: "top-center" }
//     );
//     return { status: "failed", message: data?.message || "Signup failed" };
//   } catch (error) {
//     toast.push(
//       <Notification title="Sign Up Error" type="danger" duration={4000}>
//         {error?.response?.data?.message || "Something went wrong. Please try again later."}
//       </Notification>,
//       { placement: "top-center" }
//     );
//     return {
//       status: "failed",
//       message:
//         error?.response?.data?.message ||
//         "Something went wrong. Please try again later.",
//     };
//   }
// };

//   useEffect(() => {
//     const checkSessionExpiration = () => {
//       const loginTime = localStorage.getItem("login_time");
//       if (loginTime) {
//         const elapsed = Date.now() - parseInt(loginTime, 10);
//         const sessionTimeout = 12 * 60 * 60 * 1000;

//         if (elapsed >= sessionTimeout) {
//           handleSignOut();
//           toast.push(
//             <Notification title="Session Expired" type="warning" duration={4500}>
//               Your session has expired due to inactivity.
//             </Notification>,
//             { placement: "top-center" }
//           );
//         } else {
//           setTimeout(checkSessionExpiration, sessionTimeout - elapsed);
//         }
//       }
//     };
//     checkSessionExpiration();
//   }, [handleSignOut]);

//   return {
//     authenticated: Boolean(token && signedIn),
//     signIn,
//     signUp,
//     signOut,
//   };
// }

// export default useAuth;
import { useEffect, useCallback, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setUser, initialState } from "store/auth/userSlice";
import { apiSignIn, apiSignUp, apigetUserDetails } from "services/AuthService";
import { toast, Notification } from "components/ui";
import * as Toast from 'react-toastify'
import { onSignInSuccess, onSignOutSuccess } from "store/auth/sessionSlice";
import appConfig from "configs/app.config";
import { REDIRECT_URL_KEY } from "constants/app.constant";
import { useNavigate } from "react-router-dom";
import useQuery from "./useQuery";
import { setProfile } from "store/profile/userSlice";

function useAuth() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const query = useQuery();
  const { token, signedIn } = useSelector((state) => state.auth.session);

  const [authLoading, setAuthLoading] = useState(true); 

  const handleSignOut = useCallback(() => {
    localStorage.removeItem("userDetails");
    localStorage.removeItem("access_token");
    localStorage.removeItem("login_time");
    dispatch(onSignOutSuccess());
    dispatch(setUser(initialState));
    // navigate('/sign-in');
    window.location.href = '/sign-in'
  }, [dispatch]);

  const signOut = useCallback(() => {
    handleSignOut();
  }, [handleSignOut]);

  const signIn = async (values) => {
   try {
      const resp = await apiSignIn(values);
      const { data, status } = resp;

      if (data && status === 200 && !["failed", "Failed", "Error"].includes(data.status)) {
        dispatch(onSignInSuccess(data.token));
        localStorage.setItem("access_token", data.token);
        localStorage.setItem("login_time", Date.now().toString());

        const userResp = await apigetUserDetails(data.userId);
        if (userResp.status === 200 && userResp.data) {
          const userDetails = userResp.data;
          dispatch(setProfile(userDetails))
          localStorage.setItem("userDetails", JSON.stringify(userDetails));
          toast.push(
            <Notification title="Sign In Successful" type="success" duration={5000}>
              You have successfully signed in.
            </Notification>,
            { placement: "top-center" }
          );

          const userRoles = userDetails?.userRoles || [];

          // ✅ Redirect based on role
          if (userRoles.includes("player")) {
            navigate("/");
          } else {
             navigate("/home");
          }
          // window.location.reload()
          return { status: "success" };
        }
      } else {
       Toast.toast.error(
        data?.message || data?.response || "Something went wrong. Please try again.",
        {
                autoClose: 4000,
                position: "top-right",
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
        }
      );
      
        // signOut();
      }
    } catch (error) {
      signOut();
      navigate("/sign-in");
      return Toast.toast.error(
 "Something went wrong. Please try again.",
  {
    position: "top-center"
  }
);
    }
  };

  const signUp = async (values) => {
    try {
      const resp = await apiSignUp(values);
      const { data } = resp;
      const status = data?.status?.toLowerCase();

      if (status === "success") {
        toast.push(
          <Notification title="Sign Up Successful" type="success" duration={4000}>
            {data?.message || "Check your email to activate your account."}
          </Notification>,
          { placement: "top-center" }
        );
        navigate("/sign-in");
        return { status: "success", message: data?.message || "" };
      }

      toast.push(
        <Notification title="Sign Up Failed" type="warning" duration={3000}>
          {data?.message || "Signup failed"}
        </Notification>,
        { placement: "top-center" }
      );
      return { status: "failed", message: data?.message || "Signup failed" };
    } catch (error) {
      toast.push(
        <Notification title="Sign Up Error" type="danger" duration={4000}>
          {error?.response?.data?.message || "Something went wrong."}
        </Notification>,
        { placement: "top-center" }
      );
      return {
        status: "failed",
        message: error?.response?.data?.message || "Something went wrong.",
      };
    }
  };

  useEffect(() => {
    const checkSessionExpiration = () => {
      const loginTime = localStorage.getItem("login_time");
      if (loginTime) {
        const elapsed = Date.now() - parseInt(loginTime, 10);
        const sessionTimeout = 12 * 60 * 60 * 1000;

        if (elapsed >= sessionTimeout) {
          handleSignOut();
          toast.push(
            <Notification title="Session Expired" type="warning" duration={4500}>
              Your session has expired due to inactivity.
            </Notification>,
            { placement: "top-center" }
          );
        } else {
          setTimeout(checkSessionExpiration, sessionTimeout - elapsed);
        }
      }
      setAuthLoading(false);
    };

    checkSessionExpiration();
  }, [handleSignOut]);

  return {
    authenticated: Boolean(token && signedIn),
    authLoading, 
    signIn,
    signUp,
    signOut,
  };
}

export default useAuth;
